<template>
    <v-app-bar id="nav" flat scroll-behavior="hide" density="comfortable" color="header" class="horizontal nav-teacher">
        <!--    <div id="nav" class="horizontal nav-teacher">-->

        <div v-if="school?.type.abbrv === 'WS'" id="logo" class="ws">
            <RouterLink to="/teacher/home"><img :src="`/common/img/ws.png`" /></RouterLink
            ><span>with Giglets Education</span>
        </div>
        <div v-else id="logo">
            <RouterLink to="/teacher/home"
                ><i class="icon icon-giglets"></i><span class="logo-text">giglets</span></RouterLink
            >
        </div>

        <v-spacer></v-spacer>

        <div class="nav-wrap">
            <ul>
                <li class="books">
                    <RouterLink to="/teacher/books"
                        ><i class="fa fa-book"></i><span class="title">Library</span></RouterLink
                    >
                </li>
                <li class="tasks">
                    <a id="stonly-open-resources" href="#"
                        ><i class="fa fa-suitcase"></i><span class="title">Resources</span></a
                    >
                </li>
                <li class="pupils-and-groups">
                    <RouterLink to="/teacher/pupils-and-groups"
                        ><i class="fa fa-user"></i><span class="title">Pupils &amp; Groups</span></RouterLink
                    >
                </li>
                <li class="marking">
                    <RouterLink to="/teacher/marking-overview"
                        ><i class="fa fa-check"></i><span class="title">Marking</span></RouterLink
                    >
                </li>
                <li v-if="school?.ask_teacher && school.type.abbrv === 'PREM'" class="messages">
                    <RouterLink to="/teacher/messages">
                        <i class="fa fa-message"></i>
                        <span class="title"> Messages </span>

                        <span v-show="unreadMessageCount > 0" class="fa-stack fa-3x msg-icn-cntnr-spn-tchr">
                            <i id="msg-notification" class="fa fa-comments fa-stack-2x msg-icn-tchr"></i>
                            <span class="fa fa-stack-1x">
                                <span class="msg-icn-txt-spn-tchr">
                                    <p class="msg-icn-txt-tchr">
                                        {{ unreadMessageCount > 9 ? '9+' : unreadMessageCount }}
                                    </p>
                                </span>
                            </span>
                        </span>
                    </RouterLink>
                </li>
                <li v-else-if="school && school.type.abbrv !== 'PREM'" class="messages">
                    <a href="/tlc-upgrade">
                        <i class="fa fa-message"></i>
                        <span class="title">
                            Messages
                            <i class="fa fa-lock featurelock" aria-hidden="true"></i>
                        </span>
                    </a>
                </li>

                <li v-if="school?.type.abbrv === 'PREM'" class="reporting">
                    <RouterLink to="/teacher/reporting"
                        ><i class="fa fa-pie-chart"></i><span class="title">Reporting</span></RouterLink
                    >
                </li>

                <li v-else-if="school" class="reporting">
                    <a href="/tlc-upgrade"
                        ><i class="fa fa-pie-chart"></i><span class="title">Reporting</span>
                        <i class="fa fa-lock featurelock" aria-hidden="true"></i
                    ></a>
                </li>

                <li class="account">
                    <a id="revdrop" ref="revdrop" href="#" @click="displayDropdown = !displayDropdown">
                        <i class="fa fa-cog"></i> <i class="fa fa-caret-down"></i>
                    </a>
                </li>
            </ul>
        </div>
    </v-app-bar>
    <div
        v-show="displayDropdown"
        id="dropdown"
        v-closable="{
            handler: () => (displayDropdown = false),
            exclude: ['revdrop'],
        }"
    >
        <p>Hi, {{ teacherName }}</p>
        <RouterLink to="/teacher/profile">Profile</RouterLink>
        <a
            :href="
                isProduction
                    ? 'https://app.ilteducation.co.uk/?reauthenticate=auto'
                    : 'https://app-dev.ilteducation.co.uk/?reauthenticate=auto'
            "
            >My services</a
        >
        <a @click="swapPortal('pupil')">My virtual pupil</a>
        <template v-if="school?.type.abbrv === 'PREM' && teacher?.admin">
            <template v-if="showLightControlPanel">
                <div>Admin {{ school.name }}</div>
                <a @click="swapPortal('admin')"
                    ><v-icon icon="mdi-chevron-right" size="small"></v-icon>Preferences and Reporting</a
                >
                <a :href="lightControlPanelLink" target="_blank"
                    ><v-icon icon="mdi-chevron-right" size="small"></v-icon>Manage Users</a
                >
            </template>
            <a v-else @click="swapPortal('admin')">Admin {{ school.name }}</a>
        </template>
        <a v-else-if="school?.type.abbrv !== 'PREM'" href="/tlc-upgrade">Upgrade account</a>
        <RouterLink to="/logout">Logout</RouterLink>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

const { showLightControlPanel, isProduction } = useEnv();

const store = useTeacherStore();
store.fetchTeacher();
store.fetchSchool();
store.fetchMessages();
const { teacher, school, messages } = storeToRefs(store);

const displayDropdown = ref(false);
const title = ref('');
const bodyClasses = useBodyClasses();

const unreadMessageCount = computed<number>(() => messages.value.filter((m) => !m.msg_read && m.to_teacher).length);

watchEffect(() => {
    title.value = school.value && school.value.type.abbrv === 'WS' ? 'WorldStories' : 'Giglets';
    bodyClasses.addClasses(['teachers']);
});

const teacherName = computed(() => {
    if (!teacher.value || !teacher.value.name) {
        return '';
    }
    return teacher.value.name.length < 20 ? teacher.value.name : teacher.value.name.substring(0, 20) + '...';
});

function swapPortal(type: 'teacher' | 'admin' | 'pupil') {
    useSwapPortal(type);
}

const lightControlPanelLink = computed(() => {
    return `https://panel${isProduction ? '' : '-dev'}.ilteducation.co.uk/?list=users&organization=${school.value?.uid}`;
});

useHead({ title });
</script>
<style lang="scss" scoped>
.font-size-icon {
    position: relative !important;
    max-width: 24px !important;
    overflow: visible !important;
    .small {
        left: 15px !important;
        font-size: 18px !important;
    }
    .large {
        font-size: 24px !important;
    }
}
.msg-icn-txt-spn-tchr {
    margin-top: -37px;
}
</style>
